<div class="app-page" style="padding: 16px;">
  <mat-toolbar style="background-color: var(--mat-sys-background); color: var(--mat-sys-on-background);">
    <button mat-icon-button type="button" (click)="back()" aria-label="Go back">
      <mat-icon>arrow_back_ios_new</mat-icon>
    </button>
    <span style="font-weight: 600;">{{ 'NEW_SCOUT.TITLE' | translate | uppercase }}</span>
  </mat-toolbar>

  <mat-card appearance="outlined" style="margin-top: 12px;">
    <mat-card-content>
      <div *ngIf="errorMessage" class="error-section" style="margin-bottom: 16px; color: #b00020; background: #fff0f0; padding: 12px; border-radius: 4px;">
        {{ errorMessage }}
      </div>
      <form class="form-grid" (ngSubmit)="createScout()">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_SCOUT.USERNAME' | translate }}</mat-label>
          <input matInput [(ngModel)]="model.UserName" name="userName" />
          @if (!(model.UserName || '').trim()) {
            <mat-error>{{ 'GENERAL.REQUIRED' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_SCOUT.EMAIL' | translate }}</mat-label>
          <input matInput [(ngModel)]="model.NewScoutemail" name="newScoutemail" />
          @if (!(model.NewScoutemail || '').trim()) {
            <mat-error>{{ 'GENERAL.REQUIRED' | translate }}</mat-error>
          }
          @if (isEmailInvalid()) {
            <mat-error>{{ 'NEW_SCOUT.EMAIL_INVALID' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_SCOUT.FIRSTNAME' | translate }}</mat-label>
          <input matInput [(ngModel)]="model.FirstName" name="firstName" />
          @if (!(model.FirstName || '').trim()) {
            <mat-error>{{ 'GENERAL.REQUIRED' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_SCOUT.LASTNAME' | translate }}</mat-label>
          <input matInput [(ngModel)]="model.LastName" name="lastName" />
          @if (!(model.LastName || '').trim()) {
            <mat-error>{{ 'GENERAL.REQUIRED' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_SCOUT.PASSWORD' | translate }}</mat-label>
          <input matInput type="password" [(ngModel)]="model.NewScoutPassword" name="newScoutPassword" />
          @if (!(model.NewScoutPassword || '').trim()) {
            <mat-error>{{ 'GENERAL.REQUIRED' | translate }}</mat-error>
          }
          @if (isPasswordInvalid()) {
            <mat-error>{{ 'NEW_SCOUT.PASSWORD_LENGTH' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_SCOUT.CONFIRM_PASSWORD' | translate }}</mat-label>
          <input matInput type="password" [(ngModel)]="model.NewScoutPasswordConfirm" name="newScoutPasswordConfirm" />
          @if (!(model.NewScoutPasswordConfirm || '').trim()) {
            <mat-error>{{ 'GENERAL.REQUIRED' | translate }}</mat-error>
          }
          @if (isPasswordMismatch()) {
            <mat-error>{{ 'NEW_SCOUT.PASSWORD_MISMATCH' | translate }}</mat-error>
          }
        </mat-form-field>

        <div class="section-title">{{ 'NEW_SCOUT.SCOUTING_ROLES' | translate }}</div>
        <div class="checkbox-grid">
          @for (role of roleControls; track role.field) {
            <mat-checkbox [name]="'role_' + role.field" [(ngModel)]="model[role.field]">{{ role.labelKey | translate }}</mat-checkbox>
          }
        </div>

        <div class="section-title">{{ 'NEW_SCOUT.MODULES' | translate }}</div>
        <div>
          <mat-checkbox name="modulePlayerTags" [(ngModel)]="model.Module_PlayerTags">{{ 'NEW_SCOUT.MODULE_PLAYER_TAGS' | translate }}</mat-checkbox>
        </div>

        <div class="actions-row">
          <button mat-stroked-button type="button" (click)="back()">{{ 'GENERAL.CANCEL' | translate }}</button>
          <button mat-flat-button color="primary" type="submit" [disabled]="!canCreate() || isSaving">
            @if (!isSaving) {
              <span>{{ 'NEW_SCOUT.CREATE' | translate }}</span>
            }
            @if (isSaving) {
              <span>{{ 'NEW_SCOUT.CREATING' | translate }}</span>
            }
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
